import { ArrowRightOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useContext } from 'react';

import { Badge } from 'app/components/pages/Extranet/ExtranetDashboard/_components/Badge/Badge';
import type { Task } from 'app/components/pages/Extranet/commons/TaskCenter/Legacy/Types';
import { TaskCenterContext } from 'app/context/TaskCenterContext/TaskCenterContext';

import { Tasks } from '../../../commons/TaskCenter/Legacy/Tasks/Tasks';

import './DashboardTaskCenter.scss';

const TASK_SOURCE = 'preview';

export const DashboardTaskCenter = () => {
  const { openTaskCenter, missingTasks, doneTasks, clickOpenTask } =
    useContext(TaskCenterContext);

  const nbTasks = missingTasks.length + doneTasks.length;

  const onClickUpdateButton = (taskInfo: Task) => {
    openTaskCenter();

    clickOpenTask(taskInfo, TASK_SOURCE);
  };

  return (
    <div className="extranet_taskCenter">
      <div className="taskCenter_header">
        <div className="taskCenter_title">
          Task center
          <Badge
            type={doneTasks.length === nbTasks ? 'success' : 'danger'}
            value={`${doneTasks.length} / ${nbTasks} completed`}
            isBold={true}
            style={{ padding: '1px 8px' }}
          />
        </div>
        <ArrowRightOutlined width={20} onClick={openTaskCenter} />
      </div>
      <div className="taskCenter_tasks">
        {missingTasks.length > 0 && (
          <div className="tasks_wrappaer">
            <div className="taskCenter_task_subtitle">To do</div>

            {missingTasks.map((task) => (
              <Tasks
                taskInfo={task}
                clickButton={() => onClickUpdateButton(task)}
                source={TASK_SOURCE}
                fromDashboard
              />
            ))}
          </div>
        )}
        {doneTasks.length > 0 && (
          <div className="tasks_wrappaer">
            <div className="taskCenter_task_subtitle">
              <CheckCircleOutlined />
              Done
            </div>

            {doneTasks.map((task) => (
              <Tasks
                taskInfo={task}
                clickButton={() => onClickUpdateButton(task)}
                source={TASK_SOURCE}
                fromDashboard
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
